import React from 'react';
import type { IconProps } from '../types';

export const Upload = (props: IconProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      transform="translate(1 1)"
      stroke="#8585ff"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle
        cx="8"
        cy="8"
        r="8"
      />
      <path d="M8 3.273v9.454M4 7.273l4-4 4 4" />
    </g>
  </svg>
);

export default Upload;
